import {
  CLUB_PROMO_MOVISTAR_BASE_PRICE,
  CLUB_PROMO_MOVISTAR_ID,
  CLUB_PROMO_MOVISTAR_PRICE,
  CLUB_PROMO_SANTANDER_BASE_PRICE,
  CLUB_PROMO_SANTANDER_ID,
  CLUB_PROMO_SANTANDER_PRICE,
} from '@/lib/config.ts';
import { Promo } from '@/lib/promos/contracts.ts';
import { formatCurrency } from '@/lib/utils.ts';

const promos: Promo[] = [
  {
    slug: 'club-movistar',
    title: 'Club Movistar',
    clubId: CLUB_PROMO_MOVISTAR_ID,
    banner: '/img/promos/promo-club-movistar.png',
    copy: `*Precio con descuento de ${formatCurrency(CLUB_PROMO_MOVISTAR_PRICE, {
      minimumFractionDigits: 0,
    })} durante 6 meses sobre el precio base de ${formatCurrency(CLUB_PROMO_MOVISTAR_BASE_PRICE, {
      minimumFractionDigits: 0,
    })}.`,
    benefits: [
      {
        title: '2 entradas',
        description: (
          <p>
            Para ver la peli que quieras, <strong>¡el día que quieras!</strong>
          </p>
        ),
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo… <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    extraField: {
      label: 'Código validación Club Movistar',
    },
    notes: [
      '*El valor promocional podrá ajustarse en caso de modificarse el precio base de la membresía, manteniéndose el 50% de descuento vigente.',
    ],
    enabled: true,
  },
  {
    slug: 'club-santander',
    title: 'Club Santander',
    clubId: CLUB_PROMO_SANTANDER_ID,
    banner: '/img/promos/promo-club-santander.png',
    copy: `*Precio con descuento de ${formatCurrency(CLUB_PROMO_SANTANDER_PRICE, {
      minimumFractionDigits: 0,
    })} durante 10 meses sobre el precio base de ${formatCurrency(CLUB_PROMO_SANTANDER_BASE_PRICE, {
      minimumFractionDigits: 0,
    })}.`,
    benefits: [
      {
        title: '2 entradas',
        description: (
          <p>
            Para ver la peli que quieras, <strong>¡el día que quieras!</strong>
          </p>
        ),
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo… <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    notes: [
      '*El valor promocional podrá ajustarse en caso de modificarse el precio base de la membresía, manteniéndose el 50% de descuento vigente.',
    ],
    enabled: true,
  },
];

export default promos;
